import { useContext, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MODULE_ACCESS_DENIED_MESSAGE } from "../common/apiResponse";
import { useCommonMessage } from "../common/CommonMessage";
import {
  getRouteRequiredPermissions,
  isFriendlyRouteRedirect,
} from "../common/permissions";
import { ThemeContext } from "../common/themeContext";
import { useAdminPermissions } from "../hooks/useAdminPermissions";
import Loader from "../components/Loder/loader";

const AuthMiddleware = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const messageApi = useCommonMessage();
  const { brandId } = useContext(ThemeContext);
  const deniedPathRef = useRef(null);
  const {
    isPending: profilePending,
    resolveAuthorizedRoute,
    canAccessRoute,
    profileState,
    refetchProfile,
  } = useAdminPermissions();

  useEffect(() => {
    if (localStorage.getItem("token") && brandId != null) {
      refetchProfile({ refBrandId: brandId });
    }
  }, [location.pathname, brandId, refetchProfile]);

  const needsPermissionCheck = Boolean(
    getRouteRequiredPermissions(location.pathname, brandId),
  );
  const authorizedRoute = resolveAuthorizedRoute(location.pathname);
  const shouldRedirect =
    authorizedRoute != null && authorizedRoute !== location.pathname;
  const hasRouteAccess = canAccessRoute(location.pathname);

  useEffect(() => {
    if (!shouldRedirect) {
      deniedPathRef.current = null;
      return;
    }

    if (deniedPathRef.current === location.pathname) {
      return;
    }

    deniedPathRef.current = location.pathname;

    if (
      !hasRouteAccess &&
      !isFriendlyRouteRedirect(
        location.pathname,
        authorizedRoute,
        profileState,
      )
    ) {
      messageApi.showActionError(MODULE_ACCESS_DENIED_MESSAGE);
    }

    navigate(authorizedRoute, { replace: true });
  }, [
    authorizedRoute,
    hasRouteAccess,
    location.pathname,
    messageApi,
    navigate,
    profileState,
    shouldRedirect,
  ]);

  if ((profilePending && needsPermissionCheck) || shouldRedirect) {
    return <Loader loaderTransform="loaderTransform" />;
  }

  return children;
};

export default AuthMiddleware;
